import FinanceKeyObject from './finance-key-object';
window.$ = window.jQuery = require('jquery');

export default class extends FinanceKeyObject {
    constructor(vehicle) {
        super(vehicle);
        this.pseudoKey = 'JAFPCP';
        this.key = this.getActualKeyFromKey(this.pseudoKey);
        this.name = this.getFinanceNameFromKey(vehicle, this.pseudoKey);
        this.longName = this.name;
        this.order = 2;
        this.defaultTerm = this.getDefaultTerm(vehicle.brand, 'JAFPCP');
        this.defaultMileage = this.getDefaultMileage(vehicle.brand, 'JAFPCP');
        this.mileage = false;
        this.alwaysShow = true;
        this.fallbackDeposit = {
            min: 0,
            max: Math.ceil((vehicle.price * 0.7) / 100) * 100,
        };
        this.fallbackTerms = [
            36,
            48
        ];
        this.terms = [];
        this.fallbackMileages = [
            5000,
            6000,
            7000,
            8000,
            9000,
            10000,
            12000,
            15000,
            20000
        ];

        this.isTelematics = false;
        this.requiresAge = true;
        this.requiresPostcode = true;
    }

    /**
     * Renders the sliders and sets the select box contents
     */
    init(customerParameters) {
        this.renderTermInputs(customerParameters);
        this.renderDepositInputs(customerParameters);
        this.renderMileageInputs(customerParameters);

        const postcodeElement = document.querySelector('div[data-finance-calculator="'+ this.pseudoKey +'"] input[name="postcode"]');
        postcodeElement.value = customerParameters.getPostcode();
        $(postcodeElement).on('input.' + this.pseudoKey, () => {
            customerParameters.setPostcode(postcodeElement.value);
            this.dispatchFinanceChangedEvent();
        });

        const ageElement = document.querySelector('div[data-finance-calculator="'+ this.pseudoKey +'"] input[name="age"]');
        ageElement.value = customerParameters.getAge();
        $(ageElement).on('input.' + this.pseudoKey, () => {
            customerParameters.setAge(ageElement.value);
            this.dispatchFinanceChangedEvent();
        });
    }

    getTermsAndConditions(codeweaversResponse) {
        let quote = codeweaversResponse.getFinanceProductOfInterest(this);
        if (quote.error == true) {
            return false;
        }
        let html = '';
        if (this.isFinanceModified()) {
            html = 'This is your personal quote, we will retain your deposit as you move around the website. ';
        }
        if (codeweaversResponse.vehicleObject.brand == 'vauxhall') {
            return `<span class="personal-quote">^${html}This quote is valid for a maximum of 14 days from <i>${codeweaversResponse.vehicleObject.quoteValidDate} and may be withdrawn without notice</i>.&nbsp;</span>Personal Contract Purchase. Finance subject to status, Ts&Cs apply. Applicants must be 18+. Finance by Vauxhall Finance, CF15 7YT. 26-48 month term available. We act as a credit broker, not a lender. We can introduce you to a limited number of finance providers, commission may be received.</b> <a href="/terms-and-conditions" target="_blank">Ts and Cs apply</a>`;
        }

        return `<span class="personal-quote">^${html}This quote is valid for a maximum of 14 days from <i>${codeweaversResponse.vehicleObject.quoteValidDate} and may be withdrawn without notice</i>.&nbsp;</span>Finance subject to status and age limitations. Stellantis Financial Services UK Limited RH1 1QA. <b>Stellantis &You UK Limited, trading as Stellantis &You Sales & Services, is acting as a broker not a lender and will introduce you to a limited number of lenders.</b> **The total amount payable for credit does not include any payment for services but these are included in the monthly payment. <a href="/terms-and-conditions" target="_blank">Ts and Cs apply</a>`;
    }

    getQuoteTitleValuePairs(quote) {
        if (quote.error == true) {
            return [];
        }

        let h = [];

        h.push({
            title: '<span class="term">' + quote.getNumberOfPayments() + '</span> Monthly Payments',
            emailTitle: quote.getNumberOfPayments() + ' Monthly Payments',
            value: '&pound;' + number_format(quote.getMonthlyPayment(),2)
        });

        h.push({
            title: 'Customer Cash Deposit',
            value: '&pound;' + number_format(quote.financeProduct.Quote.CashDeposit,2)
        });

        let depCon = quote.getDepositContribution();

        if (depCon > 0) {
            h.push({
                title: this.brandName() + ' Deposit Contribution',
                value: '&pound;' + number_format(depCon,2)
            });
        }

        h = this.appendVehiclePricingIncludingApplicableGrants(h, quote);

        const roadsideAssistance = quote.getRoadsideAssistance();

        h.push({
            title: this.longName + ' Price<br /><span class="smallText">Including &pound;' + roadsideAssistance + ' Roadside Assistance</span>',
            emailTitle: this.longName + ' Price - Including &pound;' + roadsideAssistance + ' Roadside Assistance',
            value: '&pound;' + number_format(quote.financeProduct.Quote.TotalPrice, 2)
        });

        h.push({
            title: 'Amount Financed',
            value: '&pound;' + number_format(quote.financeProduct.Quote.Balance,2)
        });

        h.push({
            title: 'Optional Final Payment To Buy',
            value: '&pound;' + number_format(quote.getFinalPayment(), 2)
        });

        let firstFee = quote.getFirstFee();

        h.push({
            title: 'Credit Facility Fee<br /><span class="smallText">Payable With 1st Payment</span>',
            emailTitle: 'Credit Facility Fee - Payable With 1st Payment',
            value: '&pound;' + number_format(firstFee,2)
        });


        h.push({
            title: 'Term Of Agreement',
            value: quote.financeProduct.Quote.Term + ' months'
        });

        h.push({
            title: 'Total Charge For Credit',
            value: '&pound;' + number_format(quote.financeProduct.Quote.TotalChargeForCredit,2)
        });

        h.push({
            title: 'Total Amount Of Credit',
            value: '&pound;' + number_format(quote.financeProduct.Quote.AmountOfCredit,2)
        });

        h.push({
            title: 'Total Amount Payable',
            value: '&pound;' + number_format(quote.financeProduct.Quote.TotalAmountPayable,2)
        });

        h.push({
            title: 'Fixed Rate of Interest',
            value: number_format(quote.financeProduct.Quote.RateOfInterest,2) + '%'
        });

        if (this.isFinanceModified()) {
            h.push({
                title: 'APR',
                value: number_format(quote.financeProduct.Quote.Apr,2) + '%'
            });
        } else {
            h.push({
                title: 'Representative APR',
                value: number_format(quote.financeProduct.Quote.Apr,2) + '%'
            });
        }

        h.push({
            title: 'Excess Mileage Charge',
            value: ' ' + number_format(quote.financeProduct.Quote.ExcessMileageRate,0) + ' pence per mile'
        });

        h.push({
            title: 'Annual Mileage',
            value: ' ' + number_format(quote.financeProduct.Quote.AnnualMileage,0) + '  miles'
        });

        return h;
    }

    getRelevantCustomerParameters(customerParameters) {
        return [
            {
                title: 'Requested Finance',
                value: this.longName
            },
            {
                title: 'Requested Term',
                value: this.formatTerm(customerParameters.getTerm(this)),
            },
            {
                title: 'Requested Deposit',
                value: this.formatDeposit(customerParameters.getDeposit(this)),
            },
            {
                title: 'Requested Annual Mileage',
                value: this.formatMileage(customerParameters.getMileage(this)),
            },
            {
                title: 'Customer Postcode',
                value: customerParameters.getPostcode(),
            },
            {
                title: 'Customer Age',
                value: customerParameters.getAge(),
            },
        ];
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/finance/finance-product-objects/jafpcp.js